import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Route, Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { AlertController, NavController } from '@ionic/angular';
import { AlertService } from 'src/services/alert.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    public auth: AuthService,
    public alertController: AlertController,
    public router: Router,
    public navCtrl: NavController,
    public alertService: AlertService
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const uid = await this.auth.uid();
    const approval = await this.auth.approval();
    const stop = await this.auth.stop();
    const isLoggedIn = !!uid;
    const isApproval = approval;
    const isStop = stop;
    // if (!isApproval) {
    //   this.alertService.presentAlert('알림', '현재 승인대기중입니다. 승인처리후 이용가능하십니다.');
    // }
    if (!isLoggedIn || !isApproval || isStop) {
      this.navCtrl.navigateRoot(['/start']);
      return false;
    } else {
      return isLoggedIn;
    }
  }
}
